module.exports = __webpack_public_path__ + "static/lab1-f70eba5902a6cbee0b792e1ceab34e2b.jpg";